<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" class="px-15" fxLayoutAlign="space-between center">
        <span class="title dialog-title">{{ data.titleDialog }}</span>
        <button mat-icon-button mat-dialog-close (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="content m-0 p-24" fxLayout="column">
    <p [innerHTML]="data.message"></p>
    <mat-dialog-actions *ngIf="data.cta" align="center">
        <button type="button" color="accent" (click)="dialogRef.close()" mat-dialog-close mat-raised-button>{{ data.cta }}</button>
    </mat-dialog-actions>
</mat-dialog-content>
